import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
const SectionSpacerTheme = {
    sectionSpacer: {
        light: {
            medium: {
                mobile: Spacings.xxxLarge,
                desktop: Spacings.xxxxLarge,
            },
            small: {
                mobile: Spacings.xLarge,
                desktop: createCustomSpacing(2.5),
            },
        },
        dark: {},
    },
};
export default SectionSpacerTheme;
